export default "__VITE_ASSET__B1Xey7mo__"